<template>
  <div class="index">
    <el-carousel height="13.4875rem" class="banner" arrow="always">
      <el-carousel-item v-for="(item, key) in bannerList" :key="key">
        <img :src="item.img" alt="" style="width: 100%" />
      </el-carousel-item>
    </el-carousel>
    <div class="banner_text">
      <h1>
        人生中<br />
        最美好的时光
      </h1>
      <p>- The best time of my life</p>
      <div class="banner_button more_text" @click="open()">SEE MORE</div>
    </div>
    <div class="banner_footer"></div>
    <div class="baise_kuai"></div>
    <div class="qianhu">
      <h1 class="big_title">钱湖柏庭</h1>
      <p class="small_title">Qianhu boting living</p>
      <div class="qianhu_bd">
        <div class="left_qianhu">
          <h3>项目介绍</h3>
          <div class="xian"></div>
          <div class="left_qianhu_cc">
            宁波钱湖柏庭养老投资有限公司
            <br />
            <p>
              钱湖柏庭---择址于东钱湖国家旅游度假区，是宁波知名养老企业柏庭国际养老产业集团旗下，面向健康活力长者的会员制CCRC高端养老社区。钱湖柏庭园区占地约[120亩]， 分南、北两个区域，总建筑面积约[11万平方米]， 包括 20 栋多层健康公寓、16 栋适老中式别墅。园区自然环境优美，四面环山，山水相映成趣，各类生活、休闲、运动、文教、养生、医疗等配套一应俱全，2016年开工建设，2019年2月正式开业运营。
            </p>
          </div>
          <div class="qianhu_button more_text" @click="navGetToTop('/Home/homeItem1')">
            SEE MORE
          </div>
        </div>
        <video
          id="myVideo"
          style="width: 9.1625rem"
          controls
          preload="auto"
          poster="http://img.bj.wezhan.cn/content/sitefiles/2024951/images/11352657_11.jpeg"
          src="https://wap.xbcare.com.cn/static/video/promotional-video.f20.mp4"
        ></video>
      </div>
    </div>
    <div class="news">
      <h1 class="big_title">新闻中心</h1>
      <p class="small_title2">Important notice</p>
      <div class="more" @click="navGetTo('/Home/homeItem4')">
        <span class="more_text">MORE</span><i class="el-icon-caret-right"></i>
      </div>
      <div class="lunbo">
        <div class="lunbo_left" @click="newLeftBanner()">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="lunbo_right" @click="newRightBanner()">
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="lunbo_bd">
          <div
            v-for="(item, k) in list"
            :key="k"
            class="lunbo_item"
            @click="navGetTo('/Home/homelist', item.id, item.data)"
          >
            <div class="lunbo_bd_buguize">
              <img :src="item.img" alt="" />
            </div>
            <p class="item_data">{{ item.data }}</p>
            <p class="item_contetn">{{ item.title.substr(0,50) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="party">
      <h1 class="big_title">柏庭荟</h1>
      <p class="small_title">Botingliving club</p>
      <div class="more more2" @click="navGetToTop('/Meeting/partyItem1', '0')">
        <span class="more_text">MORE</span><i class="el-icon-caret-right"></i>
      </div>
      <div class="lunbo_2">
        <div class="lunbo_2_left" @click="leftBanner()">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="lunbo_2_right" @click="rightBanner()">
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="party_bd">
          <div class="party_content_banner" v-if="curterButton == 0">
            <div
              class="party_item"
              v-for="(item, key) in bannerList1"
              :key="key"
              @click="navGetTo(item.router)"
            >
              <img :src="item.img" alt="" />
              <div class="party_bottom">
                <div class="party_title">
                  {{ item.title }}
                </div>
                <div class="party_content">
                  {{ item.content }}
                </div>
                <div class="party_cc">
                  <div class="button_party more_text" @click="navGetTo(item.router)">
                    SEE MORE
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="party_content_banner" v-if="curterButton == 1">
            <div
              class="party_item"
              v-for="(item, key) in bannerList2"
              :key="key"
              @click="navGetTo(item.router)"
            >
              <img :src="item.img" alt="" />
              <div class="party_bottom">
                <div class="party_title">
                  {{ item.title }}
                </div>
                <div class="party_content">
                  {{ item.content }}
                </div>
                <div class="party_cc">
                  <div class="button_party more_text" @click="navGetTo(item.router)">
                    SEE MORE
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="party_content_banner" v-if="curterButton == 2">
            <div
              class="party_item"
              v-for="(item, key) in bannerList3"
              :key="key"
              @click="navGetTo(item.router)"
            >
              <img :src="item.img" alt="" />
              <div class="party_bottom">
                <div class="party_title">
                  {{ item.title }}
                </div>
                <div class="party_content">
                  {{ item.content }}
                </div>
                <div class="party_cc">
                  <div class="button_party more_text" @click="navGetTo(item.router)">
                    SEE MORE
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 五有服务 -->
    <div class="wuyou">
      <h1 class="big_title">五有服务</h1>
      <p class="small_title">First-rate service</p>
      <div class="wuyou_bd">
        <div
          class="wuyou_item"
          v-for="(item, key) in list3"
          :key="key"
          @mouseover="button = key"
          @mouseleave="button = 1000"
          @click="navGetToTop(item.router)"
        >
          <img :src="item.img" alt="" />
          <p :class="button == key ? 'active title_wuyou' : 'title_wuyou'">
            {{ item.title }}
          </p>
          <div class="wuyou_content" v-if="button == key">
            <p>{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- vr -->
    <div class="vr">
      <h1 class="big_title">VR云游全览</h1>
      <p class="small_title">Vr overview</p>
      <div class="vr_bd">
        <iframe
          width="100%"
          height="100%"
          frameborder="0"
          scrolling="auto"
          src="https://720yun.com/t/cevksep7Ody"
          class="vr_item"
        ></iframe>
      </div>
    </div>

    <!-- 联系我们 -->
    <div class="lianxi">
      <h1 class="big_title">联系我们</h1>
      <p class="small_title">Contact us</p>
      <div class="lianxi_bd">
        <div class="lianxi_top"></div>
        <div class="lianxi_item">
          <div class="big_kuai"></div>
          <div class="small_kuai"></div>
          <div class="lianxi_content">
            <p>项目现场</p>

            <p>
              <img src="../assets/image/index/dianhua.png" alt="" />0574——55559888
            </p>
            <p>
              <img
                src="../assets/image/index/dizhi.png"
                alt=""
              />浙江省宁波市东钱湖旅游度假区，环湖东路环湖东路716号（原横街村）
            </p>
          </div>
        </div>
        <div class="lianxi_bottom" @click="navGetToTop('/About/contact')">
          了解更多+
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
//  import Nbmap from '../components/domestic/nbmap'
export default {
  name: "Index",
  data() {
    return {
      button: 1000,
      curterButton: 0,
      bannerList: [
        {
          img: require("../assets/image/index/banner_1.jpg"),
        },
        {
          img: require("../assets/image/index/banner_2.jpg"),
        },
        {
          img: require("../assets/image/index/banner_3.jpg"),
        },
      ],
      // ../assets/image/index/xinwen.png
      list: [
        // {
        //   img: require("../assets/image/index/xinwen_1.png"),
        //   data: "2020-08-09",
        //   content: "美好的生活从鲜花开始...",
        // },
        // {
        //   img: require("../assets/image/index/xinwen_2.png"),
        //   data: "2020-08-09",
        //   content: "有“园”相聚|城市中一处田园...",
        // },
        // {
        //   img: require("../assets/image/index/xinwen_3.png"),
        //   data: "2020-08-09",
        //   content: "情暖重阳|钱湖柏庭秋日联欢...",
        // },
      ],
      bannerList1: [
        {
          img: require("../assets/image/indexClub/yundong.png"),
          title: "运动俱乐部",
          content:
            "钱湖柏庭运动俱乐部有3个社团，分别是门球社团、乒乓球社团、台球社团。",
          router: "/Meeting/partyItem2",
          id: "1",
        },
        {
          img: require("../assets/image/indexClub/dushu.png"),
          title: "文艺俱乐部",
          content:
            "钱湖柏庭文艺俱乐部有8个社团，分别是交谊舞社团、京剧社团、民舞社团、模特社团、体育舞社团、甬剧社团、越剧社团、中国舞社团。",
          router: "/Meeting/partyItem3",
          id: "2",
        },
        {
          img: require("../assets/image/indexClub/lvyou.png"),
          title: "休闲俱乐部",
          content:
            "钱湖柏庭休闲俱乐部有7个社团，分别是电脑社团、读书社团、旅游社团、美食社团、摄影社团、养生社团、纸艺社团。",
          router: "/Meeting/partyItem4",
          id: "3",
        },
      ],
      bannerList2: [
        {
          img: require("../assets/image/indexClub/jianshen.jpg"),
          title: "健身俱乐部",
          content:
            "钱湖柏庭健身俱乐部有4个社团，分别是禅舞社团、佳木斯社团、柔力球社团、太极社团。",
          router: "/Meeting/partyItem5",
          id: "4",
        },
        {
          img: require("../assets/image/indexClub/zhuoyou.jpg"),
          title: "桌游俱乐部",
          content:
            "钱湖柏庭桌游俱乐部有3个社团，分别是国际麻将社团、棋牌社团、桥牌社团。",
          router: "/Meeting/partyItem6",
          id: "5",
        },
        {
          img: require("../assets/image/indexClub/yinyue.png"),
          title: "声乐俱乐部",
          content:
            "钱湖柏庭声乐俱乐部有2个社团，分别是器乐社团、声乐社团。",
          router: "/Meeting/partyItem7",
          id: "6",
        },
      ],
      bannerList3: [
        {
          img: require("../assets/image/indexClub/shuhua.png"),
          title: "书画俱乐部",
          content:
            "钱湖柏庭书画俱乐部有2个社团，分别是绘画社团、书法社团。",
          router: "/Meeting/partyItem8",
          id: "7",
        },
        {
          img: require("../assets/image/indexClub/waiyu.jpg"),
          title: "外语俱乐部",
          content:
            "钱湖柏庭外语俱乐部有2个社团，分别是日语社团、英语社团。",
          router: "/Meeting/partyItem9",
          id: "8",
        },
        {
          img: require("../assets/image/indexClub/yuanyi.jpg"),
          title: "园艺俱乐部",
          content:
            "钱湖柏庭园艺俱乐部有2个社团，分别是农丰社团、花艺社团。",
          router: "/Meeting/partyItem10",
          id: "9",
        },
      ],
      list3: [
        {
          img: require("../assets/image/index/fuwu_1.png"),
          title: "有套房",
          content:
            " 钱湖柏庭园区规划、设计均委托绿城集团潜心打造，将美国养老社区的产品标准本土化，以360度无死角适老化设计确保园区硬件品质。周到的适老化设计是园区精细化设计的一部分，“新关爱主义”的内在精神倡导设计师们真正从生理、心理上调研、理解老年人的需求，一切设计均做到细致全面。",
          router: "/Service/fuWuItem1",
          id: "0",
        },
        {
          img: require("../assets/image/index/fuwu_2.png"),
          title: "有块地",
          content:
            "钱湖柏庭园区配套百亩大型生态农庄，小河至东向西穿园区而过，旨在打造符合长者理想生活的最美农庄。农庄按照四季不同节气科学管理，春天观兰开，夏天可赏荷，秋天看菊落，冬天能折梅。园区还同时为每户家庭设置私人花园农场，喜欢侍弄花草的长者，可根据自己需求进行耕种，也可委托园区工作人员精心打理，使长者重回花田半亩、蛙鸣稻香的年少时光。",
          router: "/Service/fuWuItem2",
          id: "1",
        },
        {
          img: require("../assets/image/index/fuwu_4.png"),
          title: "有地暖",
          content:
            " 钱湖柏庭为长者贴心提供舒适过冬解决方案。无论是客厅、餐厅、卧室、卫生间等房间内任一个角落，还是社区内其他室内公共区域，均配备全屋地暖。长者在社区中的任何一个位置都不会感觉寒冷。",
          router: "/Service/fuWuItem3",
          id: "2",
        },
        {
          img: require("../assets/image/index/wenyi.jpg"),
          title: "有社团",
          content:
            "钱湖柏庭众多兴趣俱乐部、丰富的休闲娱乐场所、俱乐部式的社交平台，让长者的兴趣、爱好与梦想在这里实现，这也是保持年轻的上佳方法。",
          router: "/Service/fuWuItem4",
          id: "3",
        },
        {
          img: require("../assets/image/index/fuwu_5.png"),
          title: "有管家",
          content:
              "钱湖柏庭严格遵循美国养老社区标准，遴选小柏家护精英护理团队，以强大专业精神，构筑“生活、健康、快乐、物业”四大服务体系。",
          router: "/Service/fuWuItem5",
          id: "4",
        }
      ],
      newList: [],
      curterButton2: 0,
    };
  },
  methods: {
    open() {
      window.open("https://720yun.com/t/cevksep7Ody");
    },
    navGetTo(e, b, c) {
      if (c) {
        let shijian = c.slice(0, 4);
        this.$store.state.year = shijian; //存储年份
      }
      // console.log(shijian);
      this.$router.push({
        path: e,
        query: { majorName: b },
      });
    },
    navGetToTop(e,b) {
     
      this.$router.push({
        path: e,
         query: { majorName: b },
      });
       let height = this.$store.state.scrollTop;
      document.documentElement.scrollTop = height;
    },
    newLeftBanner() {
      if (this.curterButton2 == 0) {
        this.curterButton2 += 1;
      } else {
        this.curterButton2 = 0;
      }

      if (this.curterButton2 == 1) {
        this.list = this.newList.slice(3, 6);
      } else {
        this.list = this.newList.slice(0, 3);
      }
    },
    newRightBanner() {
      if (this.curterButton2 == 0) {
        this.curterButton2 += 1;
      } else {
        this.curterButton2 = 0;
      }

      if (this.curterButton2 == 1) {
        this.list = this.newList.slice(3, 6);
      } else {
        this.list = this.newList.slice(0, 3);
      }
    },
    leftBanner() {
      if (this.curterButton != 0) {
        this.curterButton--;
      } else {
        this.curterButton = 2;
      }
    },
    rightBanner() {
      if (this.curterButton != 2) {
        this.curterButton++;
      } else {
        this.curterButton = 0;
      }
    },
  },
  mounted: function () {
    var myDate = new Date();
    this.$store.state.year = myDate.getFullYear();
    let pageNumber = 1;
    axios
      .get("/api/article/paginate?categoryId=3&pageNumber=" + pageNumber)
      .then((res) => {
        let array = [];
        for (let y = 0; y < 6; y++) {
          var Person = {};
          Person.img = res.data.page.list[y].showImage;
          Person.data = res.data.page.list[y].created.substring(0, 10);
          Person.content = res.data.page.list[y].text;
          Person.title = res.data.page.list[y].title;
          Person.id = res.data.page.list[y].articleId;
          array.push(Person);
        }
        this.newList = array;
        this.list = this.newList.slice(0, 3);
      });
  },
  watch: {},
  components: {},
};
</script>
<style scoped="scoped">
.index {
  background-size: 100% 100%;
  width: 100%;
  /* height: 13.5rem; */
  /* padding: 0 .375rem; */
}
.banner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.qianhu {
  padding: 0.875rem 2.5rem 1.125rem;
  height: 11.575rem;
  background: #f2f5f8;
}
.big_title {
  font-size: 0.55rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #40684c;
  line-height: 0.375rem;
}
.small_title {
  margin-top: 0.25rem;
  font-size: 0.275rem;
  font-family: Myriad Pro;
  font-weight: 400;
  color: #9a9a9a;
  line-height: 0.4375rem;
  opacity: 0.51;
}
.small_title2 {
  margin-top: 0.25rem;
  font-size: 0.275rem;
  font-family: Myriad Pro;
  font-weight: 400;
  color: #9a9a9a;
  line-height: 0.4375rem;
}
.qianhu_bd {
  margin-top: 1rem;
  height: 6.875rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left_qianhu {
  width: 8rem;
  height: 100%;
  text-align: left;
}
.left_qianhu h3 {
  font-size: 0.45rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #40684c;
  line-height: 0.475rem;
  opacity: 0.82;
}
.xian {
  margin-top: 0.25rem;
  width: 6.6rem;
  height: 1px;
  background-color: #40684c;
}
.left_qianhu_cc {
  margin-top: 0.375rem;
  margin-left: 0.125rem;
  margin-bottom: 0.4625rem;
  font-size: 0.3375rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #9a9a9a;
  /* height: 4.6rem; */

  line-height: 0.5375rem;
  overflow: hidden;
  text-overflow: ellipsis;
}
.left_qianhu_cc p {
  text-indent: 2em;
}
.left_qianhu_cc p:nth-child(3) {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.qianhu_button {
  width: 2.25rem;
  height: 0.625rem;
  background: #bbb389;
  border-radius: 25px;
  font-size: 0.3rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.625rem;
  text-align: center;
  cursor: pointer;
}
/* 新闻中心 */
.news {
  width: 100%;
  height: 8.4125rem;
  background-image: url("../assets/image/index/xinwen.png");
  background-size: 100% 100%;
  padding: 0.775rem 1.775rem;
  color: #ffffff;
  position: relative;
}
.news .big_title {
  color: #bab388;
}
.news .small_title2 {
  color: #ffffff;
}
.more {
  position: absolute;
  width: 1.2rem;
  height: 0.25rem;
  display: flex;
  align-items: center;
  top: 0.9125rem;
  right: 2.2875rem;
  cursor: pointer;
}
.more2 {
  top: 1.725rem;
}
.more span {
  width: 0.8625rem;
  height: 100%;
  font-size: 0.25rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lunbo {
  margin-top: 0.4625rem;
  width: 100%;
  height: 5.3125rem;
  position: relative;
}
.lunbo_left {
  width: 0.7125rem;
  height: 0.7125rem;
  position: absolute;
  left: 0;
  top: 1.625rem;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lunbo_left i {
  font-size: 0.45rem;
  font-weight: 800;
}
.lunbo_right i {
  font-size: 0.45rem;
  font-weight: 800;
}
.lunbo_right {
  width: 0.7125rem;
  height: 0.7125rem;
  position: absolute;
  right: 0;
  top: 1.625rem;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lunbo_bd {
  width: 100%;
  height: 100%;
  padding: 0 1.625rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lunbo_item {
  width: 5.2rem;
  height: 100%;
  cursor: pointer;
}
.lunbo_item img {
  width: 100%;
  height: 4.575rem;
  display: inherit;
}
.item_data {
  /* position: absolute;
  top: 4.175rem; */
  margin-top: 0.25rem;
  font-size: 0.2375rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: left;
}
.item_contetn {
  margin-top: 0.125rem;
  font-size: 0.3875rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 柏亭会 */
.party {
  height: 13.8rem;
  width: 100%;
  padding-top: 1.6rem;
  position: relative;
}
.party .more span {
  color: #3f674b !important;
}
.lunbo_2 {
  margin-top: 1.0625rem;
  height: 8.75rem;
  padding: 0 0.925rem;
  position: relative;
}
.lunbo_2_left {
  top: 3.6875rem;
  left: 0;
  position: absolute;
  font-size: 1.5625rem;
  color: #eaeaea;
  cursor: pointer;
}
.lunbo_2_right {
  color: #eaeaea;
  top: 3.6875rem;
  right: 0;
  position: absolute;
  font-size: 1.5625rem;
  cursor: pointer;
}
.party_bd {
  width: 100%;
  height: 100%;
  padding: 0 2.9375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.party_content_banner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  line-height: 0.35rem;
}
.party_item {
  width: 5.1875rem;
  height: 100%;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 10px;
  cursor: pointer;
}
.party_item img {
  width: 100%;
  height: 4.15rem;
  border-radius: 10px 10px 0px 0px;
}
.party_bottom {
  width: 100%;
  height: 4.625rem;
  padding: 0px 0.4375rem 0.375rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.party_title {
  width: 100%;
  height: 1.1875rem;
  border-bottom: 1px solid #ededed;
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3f674b;
  display: flex;
  justify-content: center;
  align-items: center;
}
.party_content {
  margin-top: 0.4rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  font-size: 0.2125rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  text-align: left;
}
.party_cc {
  margin-top: 0.4375rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button_party {
  width: 1.4625rem;
  height: 0.5125rem;
  background: #bbb389;
  border-radius: 19px;
  font-size: 0.2125rem;
  font-family: Century Gothic;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
/* 五有服务 */
.wuyou {
  width: 100%;
  height: 14.7625rem;
}
.wuyou_bd {
  width: 100%;
  height: 13.8rem;
  padding: 1.1rem 2.5875rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.wuyou_item {
  height: 5.0625rem;
  width: 6.05rem;
  margin-right: 0.1875rem;
  cursor: pointer;
  position: relative;
}
.wuyou_item:nth-child(3) {
  margin-right: 0;
}
.wuyou_item img {
  width: 100%;
  height: 4.125rem;
  display: block;
  border-radius: 8px;
}
.wuyou_item .title_wuyou {
  height: 0.95rem;
  font-size: 0.4375rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3f674b;
  line-height: 0.95rem;
  /* background: #40684B; */
}
.active {
  background: #40684b;
  color: #ffffff !important;
}
.wuyou_content {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 4.125rem;
  border-radius: 10px 10px 0px 0px;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  font-size: 0.25rem;
  font-family: PingFang SC;
  font-weight: 400;
line-height: 0.4375rem;
  color: #ffffff;
  padding: 1.1875rem 0.9375rem;
}
.wuyou_content p {
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.lianxi_bd {
  width: 100%;
  height: 9.875rem;
  background-image: url("../assets/image/index/lianxi.png");
  background-size: 100% 100%;
  margin-top: 1.025rem;
  position: relative;
  padding-top: 1.1625rem;
}
.lianxi_top {
  margin-left: 2.375rem;
  width: 3.9625rem;
  height: 1.9625rem;
  background-image: url("../assets/image/index/lianxi_title.png");
  background-size: 100% 100%;
}
.lianxi_bottom {
  width: 4.225rem;
  height: 2.15rem;
  background-color: rgba(187, 179, 137, 0.5);
  /* opacity: 0.6; */
  position: absolute;
  right: 0;
  top: 5.875rem;
  font-size: 0.325rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.lianxi_item {
  margin-top: 1.375rem;
  text-align: left;
  display: flex;
}
.big_kuai {
  width: 1.7rem;
  height: 0.5rem;
  background: #40684c;
  margin-right: 0.675rem;
}
.small_kuai {
  width: 0.475rem;
  height: 0.5rem;
  background: #40684c;
  margin-right: 0.65rem;
}
.lianxi_content {
  font-size: 0.375rem;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #ffffff;
  height: 1.9625rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.lianxi_content p {
  display: flex;
  align-items: center;
}
.lianxi_content p img {
  margin-right: 0.2rem;
}
video {
  object-fit: fill;
}
.banner_footer {
  width: 100%;
  height: 2.3125rem;
  background-image: url("../assets/image/index/banner_footer.png");
  background-size: 100% 100%;
  position: absolute;
  top: 11.2rem;
  z-index: 99999;
}
.baise_kuai {
  width: 100%;
  height: 0.9125rem;
  background-color: #ffffff;
}
.lunbo_bd_buguize {
  /* border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  clip-path: polygon(
    0% 0%,
    100% 0%,
    100% 85%,
    82% 85%,
    85% 100%,
    69% 85%,
    1% 85%
  ); */
}
.lunbo_bd_buguize img {
  height: 4.25rem;
  border-radius: 10px;
  object-fit: cover;
}
.banner_text {
  width: 7.8125rem;
  height: 4.875rem;
  position: absolute;
  top: 5.825rem;
  left: 2.95rem;
  /* background: #ffffff; */
  z-index: 9999;
  text-align: left;
}
.banner_text h1 {
  font-size: 1.125rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  /* line-height: 117px; */
}
.banner_text p {
  font-size: 0.425rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.375rem;
  margin-top: 0.5625rem;
}
.banner_button {
  width: 2.25rem;
  height: 0.625rem;
  background: #ffffff;
  border-radius: 0.3125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.3rem;

  color: #40684b;
  margin-top: 0.75rem;
  cursor: pointer;
}
.vr {
  height: 14.7875rem;
  width: 100%;
  padding: 0 2.5rem 1.8125rem;
}
.vr_bd {
  width: 100%;
  height: 10.75rem;
  margin-top: 1.275rem;
  border-radius: 10px;
}
.vr_item {
  border-radius: 10px;
}
.more_text{
  font-family: 'Century Gothic';
}
</style>